import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pricingTiers } from '../../data/site';
export function PricingTiers() {
  return <ul className="mt-14 grid gap-8 lg:grid-cols-3" data-id="element-329" data-mp="1i4dcw4ekcx2t">
      {pricingTiers.map(tier => <li key={tier.name} className={`flex flex-col rounded-brand p-8 ${tier.featured ? 'bg-ink text-cream' : 'border border-ink/15 bg-cream-light'}`} data-id="element-330" data-mp="1d5sdg774yhff">
          <h3 className={`text-[0.6875rem] uppercase tracking-label ${tier.featured ? 'text-blush' : 'text-ink-muted'}`} data-id="element-331" data-mp="25to8l7h241a3">
            {tier.name}
          </h3>
          <p className="mt-6 flex items-baseline gap-2" data-id="element-332" data-mp="1vwt9amcylwur">
            <span className={`font-serif text-5xl ${tier.featured ? 'text-cream' : 'text-ink'}`} data-id="element-333" data-mp="1vye4me73ljto">
              {tier.price === 0 ? 'Free' : `$${tier.price}`}
            </span>
            <span className={`text-sm ${tier.featured ? 'text-cream/70' : 'text-ink-muted'}`} data-id="element-334" data-mp="kfjrs5de5ew3">
              {tier.cadence}
            </span>
          </p>
          <p className={`mt-5 leading-relaxed ${tier.featured ? 'text-cream/80' : 'text-ink-soft'}`} data-id="element-335" data-mp="17fb2v1doytos">
            {tier.intro}
          </p>
          <ul className="mt-8 flex flex-col gap-3" data-id="element-336" data-mp="the5w3vbsl9l">
            {tier.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-337" data-mp="yfxvqfd1ih78">
                <CheckIcon className={`mt-1 h-4 w-4 shrink-0 ${tier.featured ? 'text-blush' : 'text-brick'}`} strokeWidth={2} aria-hidden="true" data-id="element-338" data-mp="jnnofixm9b3e" />
                <span className={`text-[0.9375rem] leading-relaxed ${tier.featured ? 'text-cream/85' : 'text-ink-soft'}`} data-id="element-339" data-mp="amfpqzr6u88s">
                  {feature}
                </span>
              </li>)}
          </ul>
          <Link to={tier.to} className={`group mt-auto inline-flex items-center gap-2 pt-10 text-sm transition-colors duration-150 ease-brand ${tier.featured ? 'text-cream hover:text-blush' : 'text-brick hover:text-ink'}`} data-id="element-340" data-mp="5rjvru2e5at1">
            {tier.cta}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-341" data-mp="38y2h6b0wsdss" />
          </Link>
        </li>)}
    </ul>;
}